import type { ListQuery } from "@estelle/domain";

/**
 * What the HSN master asks its repository for: the filter and the sort.
 *
 * Not the typed search. `GET /api/catalog/hsn` does not read one, and the
 * screen has never passed it on, so the list is the same whatever is in the
 * search box. The export now sends exactly this and no more: it had begun to
 * send the search, and a term that matched nothing produced an empty file under
 * a list that still showed every code.
 *
 * One function for the screen and the export, so the two cannot differ again.
 */
export function hsnListQuery(user: ListQuery): ListQuery {
  return { filter: user.filter, sort: user.sort };
}
